import { createSelector } from 'reselect';
import {
  countryTaxTypeDescriptionsSelector,
  isFetchingCountryTaxTypeDescriptionsSelector,
  isFetchingCompanyCodesSelector,
} from '../../../shared/store/selectors';

export const bookToTaxDifferencesSelector = ({ administration }) =>
  administration.bookToTaxDifferences.bookToTaxDifferences;

export const countryTaxTypesSelector = createSelector(
  countryTaxTypeDescriptionsSelector,
  countryTaxTypes => countryTaxTypes
    ? Object.entries(countryTaxTypes).map(([key, value]) => ({ description: value, countryTaxType: key }))
    : []
);

export const countryOptionsSelector = createSelector(
  state => state.administration.bookToTaxDifferences.countries,
  countries => countries
    ? countries.map(
      ({ countryCode, countryDescription }) => ({ label: countryDescription, value: countryCode })
    )
    : []
);

export const countrySelector = ({ administration }) => administration.bookToTaxDifferences.selectedCountry;

export const accountsSelector = ({ administration }) => administration.bookToTaxDifferences.accounts;

export const bookToTaxCodeDescriptionsSelector = createSelector(
  state => state.shared.bookTypes,
  bookTypes => Array.from(new Set(bookTypes.map(({ tagDescription }) => tagDescription)))
    .map(tagDescription => ({ value: tagDescription, label: tagDescription }))
);

export const isLoadingBookToTaxDifferencesSelector = ({ administration }) =>
  administration.bookToTaxDifferences.isLoadingBookToTaxDifferences;

export const isRemovingBookToTaxDifferenceSelector = ({ administration }) =>
  administration.bookToTaxDifferences.isLoadingBookToTaxDifferenceRemove;

export const isBatchUpdatingBookToTaxDifferencesSelector = ({ administration }) =>
  administration.bookToTaxDifferences.isLoadingBookToTaxDifferenceBatchUpdate;

export const isAddingBookToTaxDifferencesSelector = ({ administration }) =>
  administration.bookToTaxDifferences.isLoadingBookToTaxDifferenceAdd;

export const isFetchingBookToTaxCodeDescriptionsSelector = ({ administration }) =>
  administration.bookToTaxDifferences.isLoadingBookToTaxCodeDescriptions;

export const isFetchingAccountsSelector = ({ administration }) =>
  administration.bookToTaxDifferences.isFetchingAccounts;

export const isUploadingBookToTaxDifferencesSelector = ({ administration }) =>
  administration.bookToTaxDifferences.isLoadingUploadedBookToTaxDifferences;

export const isImportingBookToTaxDifferencesSelector = ({ administration }) =>
  administration.bookToTaxDifferences.isLoadingBookToTaxDifferenceImport;

export const uploadedBookToTaxDifferencesSelector = ({ administration }) =>
  administration.bookToTaxDifferences.uploadedBookToTaxDifferences;

export const isFetchingBookToTaxDifferencesCountries = ({ administration }) =>
  administration.bookToTaxDifferences.isLoadingBookToTaxDifferencesCountries;

export const isRefreshingBookToTaxDifferencesSelector = ({ administration }) =>
  administration.bookToTaxDifferences.isLoadingBookToTaxDifferenceRefresh;

export const isLoadingInitialDataSelector = createSelector(
  isFetchingCountryTaxTypeDescriptionsSelector,
  isFetchingCompanyCodesSelector,
  isFetchingAccountsSelector,
  isFetchingBookToTaxCodeDescriptionsSelector,
  isFetchingBookToTaxDifferencesCountries,
  (...args) => args.some(Boolean)
);

export const isLoadingDataSelector = createSelector(
  isLoadingBookToTaxDifferencesSelector,
  isImportingBookToTaxDifferencesSelector,
  isRefreshingBookToTaxDifferencesSelector,
  isLoadingInitialDataSelector,
  (...args) => args.some(Boolean)
);
